import React from "react";
import "./What_We_Do.css";
import Common_Title from "../../common_components/common_title/Common_Title";
import Submit_Btn from "../../common_components/common_btn/submit_btn/Submit_Btn";
import { useNavigate } from "react-router-dom";

const What_We_Do = () => {
  const points = ["Commercial", "Industrial", "Residential", "Corporate"];

  const navigte = useNavigate()

  return (
    <section className="What_We_Do">
      <div className="bg_banner_div">
        <img
          src="/assets/images/home/what_we_do/bg_banner.png"
          className="banner_img"
        />
      </div>
      <div className="container">
        <div className="content_div">
          <div className="row justify-content-center me-0 ms-0" >
            <div className="col-lg-7 col-md-10 order-lg-1 order-2">
              <div className="left_side">
                <Common_Title
                  pageTitle="WHAT WE DO"
                  boxText="We Design "
                  subText=" Thoughtful, Liveable Spaces."
                  darkText="Whether it’s your home, office, or a commercial project,"
                  simpleText="we are always dedicated to bringing your vision to life. Our numbers speak better than words:"
                />

                <div className="points_main_div">
                  <div className="row">
                    {points?.map((item) => {
                      return (
                        <div className="col-6">
                          <div className="points_div">
                            <img
                              src="/assets/images/home/what_we_do/point_img.png"
                              className="point_img"
                            />
                            <p className="point_text">{item}</p>
                          </div>
                          ;
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div className="bottom_div">
                  <p className="white_text">KNOW MORE</p>
                  <div className="btn_holder">
                    <Submit_Btn btn_name="About Us" onClick={() => {navigte("/about-us")}}/>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-5 col-md-6 order-lg-2 order-1">
              <div className="img_holder">
                <img
                  src="/assets/images/home/what_we_do/img1.png"
                  className="right_img"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default What_We_Do;
